export default __webpack_public_path__ + "static/prizing_qa-1c48655c85de2b13042686413810e331.jpeg";